/* eslint-disable */
export interface StateBarcode {}

export class State implements StateBarcode {}
